import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Znamka} from '../model/znamka';
import { HttpClient } from '@angular/common/http';
import {AppService} from '../app.service';
import {Prerekvizita} from '../model/Prerekvizita';

@Component({
    selector: 'app-prerekvizity',
    templateUrl: './prerekvizity.component.html',
    styleUrls: ['./prerekvizity.component.css'],
    standalone: false
})
export class PrerekvizityComponent implements OnInit {

  prerekvizita: Prerekvizita;

  constructor(
    public dialogRef: MatDialogRef<PrerekvizityComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {znamka: Znamka, prerekvizita: Prerekvizita},
    private http: HttpClient,
    private appService: AppService
  ) {
    this.prerekvizita = data.prerekvizita;
  }

  ngOnInit(): void {
  }

}
